export default "__VITE_ASSET__DU69EYCj__";